import { Api, LogManager } from "@mcleod/core";
import { AutogenLayoutUnvoidOrderPrompt } from "./autogen/AutogenLayoutUnvoidOrderPrompt";
import { Layout } from "@mcleod/components";
import { CommonDialogs } from "@mcleod/common";

const log = LogManager.getLogger("lme.dispatch.UnvoidOrderPrompt")

export class UnvoidOrderPrompt extends AutogenLayoutUnvoidOrderPrompt {
    private _orderId: string;
    success: boolean;
    onSave: (success: boolean, promptContent: UnvoidOrderPrompt) => void;

    unvoidOrder() {
        if (this.validateSimple()) {
            return Api.post("lme/dispatch/unvoid-order", {
                order_id: this.orderId
            }, null, null).then(response => {
                this.success = response?.data[0]?.success;
                log.debug(`UNVOID was a ${this.success ? "success" : "failure"}!`)
                this.onSave(this.success, this)
            });
        }
    }

    get orderId(): string {
        return this._orderId
    }

    set orderId(value: string) {
        this._orderId = value
    }

    static async showUnvoidPrompt(orderId: string, onSave: (success: boolean, promptContent: UnvoidOrderPrompt) => void) {
        const layout = Layout.getLayout("lme/dispatch/UnvoidOrderPrompt") as UnvoidOrderPrompt;
        layout.orderId = orderId;
        layout.onSave = onSave;
        return CommonDialogs.showYesNo(layout, "Unvoid Order", {
            yesButtonProps: {
                onClick: async () => layout.unvoidOrder()
            }
        });
    }
}
